export default __webpack_public_path__ + "maps-examples-shape-collection-thumbnail-960-93848ecdcdfcf9528e8004736ee5385b.png";